import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { FullLayoutComponent } from './shared/layouts/full-layout/full-layout.component';
import { Full_Content_Routes } from './shared/routes/full.routes';
import { LandingPageComponent } from './components/landing-page/landing-page/landing-page.component';
import { landing_page_Routes } from './shared/routes/landingpage';

const routes: Routes = [
  { path: '', redirectTo: 'signin', pathMatch: 'full' },
  { path: '', component: FullLayoutComponent, children: Full_Content_Routes },
  // { path: '', component: ContentLayoutComponent, children: Content_Routes },
  {
    path: '',
    component: LandingPageComponent,
    children: landing_page_Routes,
  },
  {
    path: '',
    title: 'Customer Portal',
    loadChildren: () =>
      import('./authentication/authentication.module').then(
        (m) => m.AuthenticationModule
      ),
  },

  { path: '**', redirectTo: 'customer-portal' },
];

@NgModule({
  imports: [[RouterModule.forRoot(routes, {
    useHash: true,
    anchorScrolling: 'enabled',
    scrollPositionRestoration: 'enabled',
      onSameUrlNavigation: 'reload'
  })],
  ],
  exports: [RouterModule]
})
  
export class AppRoutingModule { }
